import React from "react";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";

const About = () => {
  return (
    <Row width="100%">
      <div>
        <Box width="100%" spacingInset="300">
          <Text type="h100">1. What is Station Command Center Labs?</Text>
          <Text>
            SCC Labs is a playground where where we play around with prototypes
            of some of our nascent or crazy ideas and get early feedback from
            our operations partners. Please note that the tools that you see in
            Labs are not guaranteed to exist in future in the Labs section, or
            in rest of the Station Command Center tool.
          </Text>
        </Box>
        <Box width="100%" spacingInset="300">
          <Text type="h100">
            2. What should I expect from experiments in SCC Labs?
          </Text>
          <Text>
            As the Last Mile Station Technology team, we believe in launching
            early and often. And SCC Labs takes that philosophy to the max. We
            intend to get early feedback for the tools showcased in the Labs
            section to help us decide if they should be turned into full-blown
            mainstream capabilities in SCC. These tools may become unavailable
            for few hours or few days, or be removed completely without notice.{" "}
          </Text>
        </Box>
        <Box width="100%" spacingInset="300">
          <Text type="h100">
            3. What will happen to these Labs tool over time?
          </Text>
          <Text>
            We will keep monitoring the usage of tool as well as listening to
            your feedback. Your comments and suggestions can elevate a Labs tool
            to a mainstream SCC capability or cause it to disappear and never be
            spoken of again.
          </Text>
        </Box>
        <Box width="100%" spacingInset="300">
          <Text type="h100">
            4. Can I cut a ticket if something does not work in a Labs tool?
          </Text>
          <Text>
            No, we do not provide a Sev2 ticket support if you face any issues
            with a tool in SCC Labs. You may however send a note to
            st-product@amazon.com if you have any suggestions related to a tool.
          </Text>
        </Box>
      </div>
    </Row>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/components/labs/About.js